import { ReuploadItemResp } from 'types/api/response/reupload-item-resp'

import { api } from './api'

export const reuploadItem = (id: number) =>
  api.post<ReuploadItemResp>(`/transactions/${id}/reupload`)
